enum SignalQuality
{
	Good = 1,
	Medium = 2,
	Bad = 3
}

export default SignalQuality;